import React from 'react'
import "./About.css"
import web from "../../asset/01.png"
import graph from "../../asset/9.jpg"
import video from "../../asset/66.png"

function About() {
  return (
    <div className='about' id='About'>
      <div className="card">
        <img src={web} alt="web" />
        <h2>Website design</h2>
        <p> Proficient in HTML, CSS, JavaScript, React JS, React Native for front-end development. Skilled in MongoDB, Express JS, Node JS, PHP, MySQL for back-end solutions. Adept in responsive design, cross-browser compatibility, and UI/UX principles. Experienced in Git for version control. Known for effective problem-solving and troubleshooting skills.</p>
      </div>
      <div className="card">
        <img src={graph} alt="graph" />
        <h2>Graphics design</h2>   
        <p>Creative Graphic Designer skilled in Adobe Illustrator and Adobe Photoshop. Specializing in precision vector graphics and image manipulation, I bring ideas to life with attention to detail and a commitment to aesthetic excellence. Versatile in design, I craft captivating visuals for diverse projects, staying innovative and adaptable to trends. Let's collaborate to make your creative vision a reality! </p>
      </div>
      <div className="card">
        <img src={video} alt="video" />
        <h2>Video editting</h2> 
        <p>Video Editing and Motion Graphics Pro adept in Adobe Premiere, After Effects, and CutCut. Crafting captivating stories and dynamic animations, I bring innovation to every project. Ready to collaborate on visually stunning content. Let's create together!</p>
      </div>
    </div>
      
  )
}

export default About